function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { has, isFunction } from 'lodash';
import T from 'prop-types';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../../../../components/icon/Icon';
import { AMPLITUDE_EVENTS } from '../../../../../constants/analytics';
import { toggleRightMenuVisibility } from '../../../../../redux/actions';
import { clearTourSelected, putTourStatus } from '../../../../../redux/actions/tour';
import text from '../../../../../text';
import { amplitudeTrack } from '../../../../../utilities';
var SITE_TOUR_ACTIVITY = AMPLITUDE_EVENTS.SITE_TOUR_ACTIVITY;
export default function TourContent(props) {
    var _props_steps_currentStep, _props_steps_currentStep1;
    var totalSteps = props.steps.length;
    var currentStep = props.currentStep;
    var isFirstStep = currentStep === 0;
    var isLastStep = currentStep === totalSteps - 1;
    var content = (_props_steps_currentStep = props.steps[currentStep]) === null || _props_steps_currentStep === void 0 ? void 0 : _props_steps_currentStep.content;
    var customProps = ((_props_steps_currentStep1 = props.steps[currentStep]) === null || _props_steps_currentStep1 === void 0 ? void 0 : _props_steps_currentStep1.customProps) || {};
    var dispatch = useDispatch();
    var tourSelected = useSelector(function(state) {
        return state.tourReducer.tourSelected;
    });
    var handleNextButton = function() {
        var executeStep = function() {
            if (isLastStep) {
                props.setIsOpen(false);
            } else {
                props.setCurrentStep(function(s) {
                    return s + 1;
                });
            }
        };
        if (has(customProps.callback, 'next') && isFunction(customProps.callback.next)) {
            customProps.callback.next();
        }
        if (has(customProps, 'stepDelay') && customProps.stepDelay > 0) {
            setTimeout(function() {
                return executeStep();
            }, customProps.stepDelay + 10);
        } else {
            executeStep();
        }
    };
    var handlePrevButton = function() {
        if (has(customProps.callback, 'next') && isFunction(customProps.callback.prev)) {
            customProps.callback.prev();
        }
        if (has(customProps, 'stepDelay') && customProps.stepDelay > 0) {
            setTimeout(function() {
                return props.setCurrentStep(function(s) {
                    return s - 1;
                });
            }, customProps.stepDelay + 10);
        } else {
            props.setCurrentStep(function(s) {
                return s - 1;
            });
        }
    };
    useEffect(function() {
        console.log('DEBUG', content);
    }, [
        content
    ]);
    var _obj;
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        },
        className: classNames('TourContent p-3 px-4 with-caret', (_obj = {}, _define_property(_obj, "caret-".concat(customProps === null || customProps === void 0 ? void 0 : customProps.caret), !!customProps && customProps.caret), _define_property(_obj, "caretPosY-".concat(customProps === null || customProps === void 0 ? void 0 : customProps.caretPosY), !!customProps && customProps.caretPosY), _obj))
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "close",
        onClick: function() {
            amplitudeTrack(SITE_TOUR_ACTIVITY.EVENT, {
                action: SITE_TOUR_ACTIVITY[tourSelected]['INC']
            });
            dispatch(putTourStatus(tourSelected));
            dispatch(toggleRightMenuVisibility(false));
            dispatch(clearTourSelected());
            props.setIsOpen(false);
        }
    }), content(), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row justify-content-end",
        style: {
            gap: 8
        }
    }, !isFirstStep && /*#__PURE__*/ React.createElement(Button, {
        variant: "light",
        className: "mt-4 grey-2",
        onClick: handlePrevButton
    }, text('previous')), /*#__PURE__*/ React.createElement(Button, {
        className: "mt-4",
        onClick: handleNextButton
    }, "".concat(text(isLastStep ? 'complete' : 'next'), " (").concat(currentStep + 1, "/").concat(totalSteps, ")"))));
}
TourContent.propTypes = {
    steps: T.array,
    currentStep: T.number,
    setIsOpen: T.func
};
export var StepContent = function(param) {
    var title = param.title, description = param.description, externalLinkHelp = param.externalLinkHelp, children = param.children;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h5", {
        className: "mb-3 green-1 mt-2"
    }, title), description && /*#__PURE__*/ React.createElement("p", {
        className: "mb-0"
    }, description), children, externalLinkHelp && /*#__PURE__*/ React.createElement("span", null, "(", /*#__PURE__*/ React.createElement("a", {
        href: externalLinkHelp,
        target: "_blank",
        rel: "noopener noreferrer"
    }, text('learnMore')), ")"));
};
StepContent.propTypes = {
    title: T.string.isRequired,
    description: T.string,
    externalLinkHelp: T.string,
    children: T.oneOfType([
        T.element,
        T.string
    ])
};
